/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon16Solid = forwardRef('LogoMicrosoftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.25 2H2v5.25h5.25V2Z" }),
        React.createElement("path", { d: "M7.25 8.75H2V14h5.25V8.75Z" }),
        React.createElement("path", { d: "M8.75 2H14v5.25H8.75V2Z" }),
        React.createElement("path", { d: "M14 8.75H8.75V14H14V8.75Z" })));
});
